import React, { useState } from "react";
import Slider from "react-slick";
import styles from "./css/FranchisePartner.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Player } from "video-react"; // Or any other player you're using
import "video-react/dist/video-react.css"; // Required if using video-react
const newsData = [
  {
    image:
      "https://media.istockphoto.com/id/1399788030/photo/portrait-of-young-confident-indian-woman-pose-on-background.jpg?s=612x612&w=0&k=20&c=aQw5YhGl99hL1O77thwpQTmqVE7bc8rCX9H0gTeoX_k=",
  },
  {
    image:
      "https://media.istockphoto.com/id/1320811419/photo/head-shot-portrait-of-confident-successful-smiling-indian-businesswoman.jpg?s=612x612&w=0&k=20&c=bCUTB8vd8MnzZFIq-x645-SmLNk2sQzOvOvWCPGDfZ4=",
  },
  {
    image:
      "https://media.istockphoto.com/id/1442187007/photo/profile-picture-of-young-indian-woman-posing.jpg?s=612x612&w=0&k=20&c=2KKTqAl-ekv2af4MYDNnSPA93fTahYyT3BDVY7mhPYc=",
  },
  {
    image:
      "https://media.istockphoto.com/id/1341094522/photo/calm-millennial-indian-lady-breath-deep-meditate-with-closed-eyes.jpg?s=612x612&w=0&k=20&c=6W6YUsGWj7pN-s1xUKH6S6R-YGQ6i8ZP1tbeVpKh4AQ=",
  },
  {
    image:
      "https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=",
  },
  {
    image:
      "https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=",
  },
];

export default function FranchisePartner() {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true, // ✅ enable auto-slide
    autoplaySpeed: 2000, // ✅ time (ms) between slides (2s here)
    pauseOnHover: true, // ✅ optional (pause when hovered)
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Franchise Partners</h3>
      <div className={styles.sliderWrapper}>
        <Slider {...settings}>
          {newsData.map((item, index) => (
            <div key={index} className={styles.cardWrapper} onClick={openModal}>
              <div className={styles.imageOnlyCard}>
                <img
                  src={item.image}
                  alt={`Partner ${index + 1}`}
                  className={styles.newsImage}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {isOpen && (
        <div style={styless.overlay}>
          <div style={styless.modal}>
            <button onClick={closeModal} style={styless.closeButton}>
              ✖
            </button>
            <br></br>
            <br></br>

            <Player
              autoPlay
              muted
              playsInline
              style={{
                width: "100%",
                height: 250,
                marginTop: 10,
                position: "relative",
              }}
            >
              <source src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4" />
            </Player>
          </div>
        </div>
      )}
    </div>
  );
}

const styless = {
  button: {
    fontSize: "18px",
    padding: "10px 20px",
    cursor: "pointer",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    width: "90%",
    maxWidth: "600px",

    padding: "10px",
    position: "relative",
    borderRadius: "8px",
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
    background: "transparent",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
};
